'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { mixpanelClient } from '@/utils';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';

export default function AnalyticsProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const userData = useSelector((state: RootState) => state.user.user);

  useEffect(() => {
    if (userData) {
      mixpanelClient.identifyUser(userData?._id, {
        Name: userData.name,
        Email: userData.email,
        Phone: userData.mobile,
        'User Role': 'customer',
      });
    }
  }, [userData]);

  useEffect(() => {
    mixpanelClient.initMixpanel();
    mixpanelClient.trackPageView(pathname);
  }, [pathname]);

  return <>{children}</>;
}
